import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("oda_token"));
  const [role, setRole] = useState(() => localStorage.getItem("oda_role") || "admin");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const check = async () => {
      if (!token) {
        setReady(true);
        return;
      }
      try {
        const res = await api.verify();
        if (res?.role) {
          setRole(res.role);
          localStorage.setItem("oda_role", res.role);
        }
      } catch {
        localStorage.removeItem("oda_token");
        localStorage.removeItem("oda_role");
        setToken(null);
      } finally {
        setReady(true);
      }
    };
    check();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (password) => {
    const { token: t, role: r } = await api.login(password);
    localStorage.setItem("oda_token", t);
    localStorage.setItem("oda_role", r || "admin");
    setToken(t);
    setRole(r || "admin");
    return true;
  };

  const logout = () => {
    localStorage.removeItem("oda_token");
    localStorage.removeItem("oda_role");
    setToken(null);
    setRole("admin");
    window.location.href = "/login";
  };

  const isViewer = role === "viewer";
  const canWrite = role === "admin";

  return (
    <AuthContext.Provider
      value={{ token, role, isViewer, canWrite, isAuthed: !!token, ready, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
